export const organisation = {
  name: "CLEARITH",
  legalForm: "SAS, société par actions simplifiée",
  siren: "988 127 122",
  siret: "988 127 122 00014",
  vatNumber: "FR74 988 127 122",
  activityDeclaration: "11922944992",
  address: "40 rue Madeleine Michelis, 92200 Neuilly-sur-Seine",
  declarationRegion: "Île-de-France",
  qualiopiScope: "Actions de formation",
  status: "Organisme de formation à jour de ses obligations",
  speciality:
    "Informatique, traitement de l’information et réseaux de transmission des données",
  email: "contact@clearith.fr",
  legalNotice:
    "La déclaration d’activité est enregistrée sous le numéro 11922944992 auprès du préfet de région d’Île-de-France. Cet enregistrement ne vaut pas agrément de l’État.",
};

export interface Training {
  slug: string;
  title: string;
  certification: string;
  certifier: string;
  duration: string;
  organisation: string;
  rhythm: string;
  price: string;
  certificationFees: string;
  modality: string;
  prerequisite: string;
  audience: string;
  objective: string;
  skills: string[];
  modules: { title: string; description: string }[];
  pedagogy: string[];
  evaluation: string[];
}

export const trainings: Training[] = [
  {
    slug: "vtest-business-english-4-skills",
    title: "VTest Business English – 4 Skills",
    certification: "RS6905 – VTest Business English – 4 Skills",
    certifier: "ExAssess / VTest",
    duration: "28 heures",
    organisation: "4 modules de 7 heures",
    rhythm: "4 à 8 semaines",
    price: "2 300 € TTC par participant",
    certificationFees: "Inclus",
    modality: "Formation à distance avec classes virtuelles interactives",
    prerequisite: "Niveau A2 minimum du CECRL",
    audience:
      "Salariés, managers, dirigeants, indépendants, entrepreneurs, demandeurs d’emploi et professionnels utilisant l’anglais dans leur activité.",
    objective:
      "Permettre au participant de comprendre, interagir, s’exprimer et rédiger en anglais dans un contexte professionnel, tout en préparant les quatre compétences évaluées par la certification.",
    skills: [
      "Compréhension orale",
      "Compréhension écrite",
      "Expression orale",
      "Expression écrite",
    ],
    modules: [
      {
        title: "Communication professionnelle essentielle",
        description:
          "Acquérir les réflexes linguistiques utiles aux échanges professionnels du quotidien.",
      },
      {
        title: "Réunions, coordination et projets",
        description:
          "Participer aux réunions, coordonner une activité et communiquer autour d’un projet.",
      },
      {
        title:
          "Relations clients, partenaires et situations professionnelles complexes",
        description:
          "Adapter sa communication aux interlocuteurs et gérer des échanges à plus fort enjeu.",
      },
      {
        title:
          "Structuration du discours, influence et préparation à la certification",
        description:
          "Renforcer la précision du discours et se préparer aux quatre compétences certifiées.",
      },
    ],
    pedagogy: [
      "Classes virtuelles interactives",
      "Mises en situation professionnelles",
      "Exercices pratiques",
      "Accompagnement individualisé",
      "Supports pédagogiques numériques",
      "Préparation à la certification",
    ],
    evaluation: [
      "Évaluations régulières pendant le parcours",
      "Exercices et mises en situation professionnelles",
      "Préparation aux quatre compétences évaluées",
      "Passage de la certification VTest Business English – 4 Skills",
    ],
  },
];

export const audiences = [
  "Salariés",
  "Demandeurs d’emploi",
  "Indépendants",
  "Entrepreneurs",
  "Managers",
  "Dirigeants",
  "Professionnels",
];

export const pedagogyItems = [
  {
    number: "01",
    title: "Classes virtuelles",
    text: "Des séances interactives à distance pour échanger, pratiquer et progresser avec le formateur.",
  },
  {
    number: "02",
    title: "Mises en situation",
    text: "Des activités ancrées dans des contextes professionnels concrets et directement mobilisables.",
  },
  {
    number: "03",
    title: "Parcours personnalisé",
    text: "Un accompagnement adapté aux objectifs, au niveau et au rythme de chaque participant.",
  },
  {
    number: "04",
    title: "Évaluations régulières",
    text: "Des points d’étape pour mesurer les acquis et ajuster la progression pédagogique.",
  },
  {
    number: "05",
    title: "Ressources numériques",
    text: "Des supports pédagogiques accessibles à distance pour consolider les apprentissages.",
  },
  {
    number: "06",
    title: "Objectif certification",
    text: "Une préparation structurée aux compétences et aux modalités de la certification visée.",
  },
];

export const fundingOptions = [
  {
    title: "CPF",
    text: "Sous réserve de l’éligibilité et de la publication effective de l’offre sur la plateforme dédiée.",
  },
  {
    title: "OPCO",
    text: "Une demande peut être présentée à l’opérateur de compétences dont dépend l’entreprise.",
  },
  {
    title: "Employeur",
    text: "Le parcours peut être étudié dans le cadre du plan de développement des compétences.",
  },
  {
    title: "Financement personnel",
    text: "Le participant peut financer directement tout ou partie de son parcours.",
  },
  {
    title: "France Travail et autres dispositifs",
    text: "Une prise en charge peut être sollicitée selon la situation et sous réserve d’acceptation du dossier.",
  },
];
